<template>
  <div class="py-2 px-3">
    <h5 class="grey--text">
      {{ $t('appointment.label.cancellationOrigin') }}
    </h5>
    <p class="text-body-2 mb-0">
      {{ cancelReason }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'BoardCardCancelContent',

  props: {
    cancelReason: {
      type: String,
    },
  },
}
</script>
